import React from 'react';
import { Col, Row, Card, Badge, Button } from 'react-bootstrap';

const UKComplianceOverview = () => {
  return (
    <>
      <Card style={{ height: '100%' }}>
        <Card.Header>
          <h5 className="text-lg font-medium leading-6 text-gray-900">
            UK Compliance Overview
          </h5>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col>
              <Card>
                <Card.Body>
                  <strong>HRMC Submission Status</strong>
                  <Badge bg="success" className="float-end">
                    Up to date
                  </Badge>
                  <br />
                  <p>Last submitted: 15 Apr 2025</p>
                  <Button className="btn-sm" variant="light">
                    View History
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card>
                <Card.Body>
                  <strong>Real-time Information (RTI)</strong>
                  <Badge bg="success" className="float-end">
                    Enabled
                  </Badge>
                  <br />
                  <p>Next submission: 30 Apr 2025</p>
                  <Button className="btn-sm" variant="light">
                    RTI Settings
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card className="mt-3">
                <Card.Body>
                  <strong>Tax Year Overview</strong>
                  <Badge bg="info" className="float-end">
                    2025-2026
                  </Badge>
                  <br />
                  <p>Year end: 5 Apr 2026</p>
                  <Button className="btn-sm" variant="light">
                    Year End Reports
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className="mt-3">
                <Card.Body>
                  <strong>Automatic Calculations</strong>
                  <br />
                  PAYE{' '}
                  <Badge bg="success" className="float-end">
                    Active
                  </Badge>
                  <br />
                  National Insurance{' '}
                  <Badge bg="success" className="float-end">
                    Active
                  </Badge>
                  <br />
                  Pension Contributions{' '}
                  <Badge bg="success" className="float-end">
                    Active
                  </Badge>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};
export default UKComplianceOverview;
